import React from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import { useAuth } from "../../Context/AuthContext";
import { GuidGenerator } from "../../Util/Helpers/GuidGenerator";

export default function ImportFromYear() {
  const { data, setData } = useAuth();
  const activeYear = useSelector((state) => state.year);

  //import from other year
  function importDataToYearHandler(importFromYear) {
    //filter year to copy
    const filteredList = data.data.filter(
      (item) => item.year === importFromYear
    );
    //create new id and update year to new year
    const importedYear = filteredList.map((item) => {
      return { ...item, id: GuidGenerator(), year: activeYear.year };
    });
    const newList = [...data.data];
    //add updated object to new year list
    const updatedList = [...newList.concat(importedYear)];
    //set new list to fixedCostData
    setData({ data: updatedList });
  }

  const toggleSort = (str) => {
    if (str === "importFromYear1") {
      importDataToYearHandler("year1");
    } else if (str === "importFromYear2") {
      importDataToYearHandler("year2");
    } else if (str === "importFromYear3") {
      importDataToYearHandler("year3");
    }
  };

  return (
    <Row className="g-0">
      <Col xs={6} style={{ margin: "0px", padding: "0px" }}>
        <select
          className="sorter rounded-3"
          onChange={(e) => toggleSort(e.target.value)}
        >
          {activeYear.year === "year1" ? (
            <>
              <option className="sorter-option" value="placeholder">
                Importera från år
              </option>
              <option className="sorter-option" value="importFromYear2">
                Importera från år 2
              </option>
              <option className="sorter-option" value="importFromYear3">
                Importera från år 3
              </option>
            </>
          ) : activeYear.year === "year2" ? (
            <>
              <option className="sorter-option" value="placeholder">
                Importera från år
              </option>
              <option className="sorter-option" value="importFromYear1">
                Importera från år 1
              </option>
              <option className="sorter-option" value="importFromYear3">
                Importera från år 3
              </option>
            </>
          ) : (
            <>
              <option className="sorter-option" value="placeholder">
                Importera från år
              </option>
              <option className="sorter-option" value="importFromYear1">
                Importera från år 1
              </option>
              <option className="sorter-option" value="importFromYear2">
                Importera från år 2
              </option>
            </>
          )}
        </select>
      </Col>
    </Row>
  );
}
